export const INTERACTION_MODE_CHANGE_ANIMATION_DURATION = 0.5;
export const INTERACTION_HOVER_ANIMATION_DURATION = 0.5;
export const RIPPLE_DEFAULT_ANIMATION_DURATION = 4;
export const GLOW_IMG_SRC = "https://dapulse-res.cloudinary.com/image/upload/v1707905637/Generator_featured%20images/Homepage%20-%202024/michael-testing/Ellipse_5790.png";
export const SYSTEM_BACKGROUND_IMG_SRC = "https://dapulse-res.cloudinary.com/image/upload/v1707905613/Generator_featured%20images/Homepage%20-%202024/michael-testing/system_layout.png";
